import React from 'react';
import PropTypes from 'prop-types';
import { ListItem, NavItem, Heading } from '@tesla/design-system-react';
import Styles from '../../vehicleTabs.module.css.js';
import { useTabConfigContext } from '../../Context/index.js';

var TextTab = function TextTab(props) {
  var id = props.id,
    externalUrl = props.externalUrl,
    tabName = props.tabName,
    onTabClick = props.onTabClick;
  var _useTabConfigContext = useTabConfigContext(),
    translations = _useTabConfigContext.translations;
  if (!tabName) {
    return null;
  }
  var translatedLabel = translations ? translations(tabName) : tabName;
  var onClick = function onClick(event) {
    event.preventDefault();
    if (onTabClick) {
      onTabClick(props);
    } else {
      window.open(externalUrl, '_self');
    }
  };
  var checkIsSelected = window.location.href.includes(externalUrl) ||
  // a temp check, ownership history page have one more `/` in url which should not show.
  window.location.href.toLocaleLowerCase().includes(tabName.split(' ')[0].toLowerCase());
  return /*#__PURE__*/React.createElement(ListItem, {
    key: id,
    id: id
  }, /*#__PURE__*/React.createElement(NavItem, {
    onClick: onClick,
    className: Styles['tw-react--vehicle-tabs--tab--gap10'],
    selected: checkIsSelected
  }, /*#__PURE__*/React.createElement(Heading, {
    className: "tds--no_padding",
    is: "span",
    looksLike: "h6"
  }, translatedLabel)));
};
TextTab.propTypes = {
  tabName: PropTypes.string,
  id: PropTypes.string.isRequired,
  externalUrl: PropTypes.string.isRequired,
  onTabClick: PropTypes.func
};
TextTab.defaultProps = {
  tabName: '',
  onTabClick: undefined
};

export { TextTab as default };
